<template>
    <div class="modal-container">
        <div class="modal">
            <h5 v-if="title" class="modal-title">{{ title }}</h5>
            <p v-if="message" class="modal-text">{{ message }}</p>
            <div class="modal-buttons">
                <span
                    v-if="cancelShow"
                    v-on:click="$emit('cancel')"
                    class="button button-gray"
                >
                    {{ cancelLabel ? cancelLabel : $t('components.modal.cancel') }}
                </span>
                <span
                    v-if="confirmShow"
                    v-on:click="$emit('confirm')"
                    class="button button-blue"
                >
                    {{ confirmLabel ? confirmLabel : $t('components.modal.confirm') }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Modal',
    props: {
        title: {
            type: String,
            required: false,
        },
        message: {
            type: String,
            required: false,
        },
        cancelShow: {
            type: Boolean,
            required: false,
            default: false,
        },
        cancelLabel: {
            type: String,
            required: false,
        },
        confirmShow: {
            type: Boolean,
            required: false,
            default: true,
        },
        confirmLabel: {
            type: String,
            required: false,
        },
    },
};
</script>
